<template>
  <a-modal
    ref="createModal"
    :title="fromType === 'edit' ? '快码编辑' : '新增操作'"
    :width="640"
    :visible="visible"
    :maskClosable="false"
    @cancel="close"
    @ok="confirm"
    :confirmLoading="confirmLoading"
  >
    <a-spin :spinning="loading">
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="快码域" prop="parentId">
          <a-select v-model="parentId" disabled>
            <a-select-option v-for="(item) in lookupList" :key="item.key">{{ item.value }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="快码" prop="lookupType">
          <a-input v-model="form.lookupType" placeholder="请输入参数键名" />
        </a-form-model-item>
        <a-form-model-item label="快码说明" prop="lookupName">
          <a-input v-model="form.lookupName" placeholder="请输入参数名称" />
        </a-form-model-item>
        <a-form-model-item label="状态" prop="status">
          <a-radio-group button-style="solid" v-model="form.status">
            <a-radio-button
              v-for="dict in statusOptions"
              :key="dict.dictValue"
              :value="dict.dictValue">
              {{ dict.dictLabel }}
            </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="备注" prop="remark">
          <a-textarea
            rows="4"
            placeholder="请输入备注"
            v-model="form.remark" />
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
import { apiLookupTypeAdd, apiLookupTypeUpdate } from '@/api/system/lookup/type'
// 表单字段
export default {
  props: {
    parentId: {
      type: [Number, String],
      default: null
    },
    lookupList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      // 状态数据字典
      statusOptions: [
        {
          dictLabel: "正常",
          dictValue: "0"
        },
        {
          dictLabel: "停用",
          dictValue: "1"
        }
      ],
      // 当前控件配置:
      confirmLoading: false,
      // readOnly: false,
      visible: false,
      loading: false,
      labelCol: {
        xs: { span: 12 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        lookupName: [
          { required: true, message: '快码名称不能为空', trigger: 'blur' }
        ],
        lookupType: [
          { required: true, message: '快码类型不能为空', trigger: 'blur' }
        ]
      },
      fromType: ""
    }
  },
  created () {
    // this.getDicts('sys_normal_disable').then(response => {
    //   this.statusOptions = response.data
    // })
  },
  methods: {
    // 由于要用传进来的值做判断,将显示和隐藏放在内部做处理
    show (data) {
      if (data) {
        // 修改行为
        this.form = Object.assign({}, data) || {}
        this.parentId = this.form.parentId
        this.fromType = "edit"
      } else {
        this.reset()
        // 新增行为
        // 刷新表单,查询角色树
        this.form.parentId = this.parentId
        this.fromType = "add"
      }
      this.visible = true
    },
    // 关闭模态框
    close () {
      this.visible = false
      this.reset()
    },
    // 保存
    confirm () {
      this.confirmLoading = true
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          // 进行新增行为:
          if (this.fromType === "edit") {
            // 刷新表格
            apiLookupTypeUpdate(this.form).then(response => {
              if (response.code === 200) {
                this.$message.success('修改成功')
                // 关闭本组件
                this.visible = false
                // 调用外部刷新列表方法
                this.$emit('handle-success')
                // 刷新表单
                this.reset()
                this.confirmLoading = false
              } else {
                this.$message.error(response.msg)
                this.confirmLoading = false
              }
            })
          } else {
            // 新增
            apiLookupTypeAdd(this.form).then(response => {
              if (response.code === 200) {
                this.$message.success('新增成功')
                // 关闭本组件
                this.visible = false
                // 调用外部刷新列表方法
                this.$emit('handle-success')
                // 刷新表单
                this.reset()
                this.confirmLoading = false
              } else {
                this.$message.error(response.msg)
                this.confirmLoading = false
              }
            })
          }
        } else {
          return (this.confirmLoading = false)
        }
      })
    },
    // 表单重置
    reset () {
      this.form = {
        parentId: undefined,
        lookupName: undefined,
        lookupType: undefined,
        status: undefined,
        remark: undefined
      }
    }
  }
}
</script>
